RCA.client.Notify = (function () {
    /* ----- Init ----------------------------------------------------------------------------------------------------- */
    var layoutToShow;
    var notify;

    function show(data) {
        notify = $('#notify');
        notify.find('.notify-title').text(RCA.shared.Language.getItem(data.title));
        notify.find('.notify-text').text(RCA.shared.Language.getItem(data.text));
        layoutToShow = data.layoutToShow;
        RCA.client.Layout.show('notify');
    }

    function evtButtonClick() {
        if (layoutToShow) {
            RCA.client.Layout.swap(layoutToShow);
        } else {
            RCA.client.Layout.hide('notify');
        }
    }

    $(document)
        .on('click', '#notify .notify-btn', evtButtonClick);
    /* ----- Public API ----------------------------------------------------------------------------------------------- */
    return {
        show: show
    }
})();
